export const addScript = (url) => {
  const script = document.createElement('script');
  script.setAttribute('src', url);
  document.head.appendChild(script);

  return script;
};
